module.exports = __webpack_public_path__ + "static/img/celan_btn.0955041f.png";